const help = {
    supportedFormats: '対応形式: {{types, list}}',
    supportedFormatsUnavailable: '対応形式を取得できませんでした。時間をおいて再読み込みしてください。',
    faq: {
      searchQuestion: 'ドキュメントを検索するにはどうすればいいですか？',
      searchAnswer: 'サイドバーの「検索」メニューから検索ページにアクセスできます。キーワードや自然文を入力すると、関連する文書、抜粋、参照元ページを確認できます。',
      uploadQuestion: 'ドキュメントをアップロードするにはどうすればいいですか？',
      uploadAnswer: 'サイドバーの「ドキュメントをアップロード」をクリックし、ファイルを選択してください。AI（GPT-4）がタイトル・要約・カテゴリ・タグを自動抽出し、図面や画像も含めて全文検索できるようインデックス化します。',
      chatQuestion: 'AIチャット機能の使い方を教えてください',
      chatAnswer: '画面右上のチャットアイコンからチャットパネルを開けます。ドキュメントに関する質問をすると、関連情報を検索して回答します。回答カードでは参照文書の関連度や根拠を確認できます。',
      chatFileScopeQuestion: '特定のファイルだけを対象にチャットしたいときは？',
      chatFileScopeAnswer: 'チャット入力欄の「コンテキスト追加」ボタンから対象ドキュメントを選択すると、そのファイルに限定した Q&A ができます。検索結果カードのチェックボックスからも同じ挙動でコンテキストに追加できます。',
      drbfmQuestion: 'DRBFM分析機能はどのように使いますか？',
      drbfmAnswer: 'サイドバーの「DRBFM分析」からアクセスできます。部品名と旧／新仕様書を入力すると、AI が設計変更点・心配点・対策案を生成します。故障モードの関連知識は実ファイルリンク・抜粋・関連度付きで確認できます。',
      verificationQuestion: '設計検証項目一覧の使い方を教えてください',
      verificationAnswer: 'サイドバーの「設計検証項目」からアクセスできます。検証セッションを作成し、ユニット（大分類）と検証項目を追加していきます。分類（性能・機能・信頼性など）と検証方法をマトリクス形式で管理でき、Excel出力や DRBFM からの自動変換にも対応しています。',
      cadQuestion: '3D CAD ビューアでは何ができますか？',
      cadAnswer: 'サイドバーの「3D CADビューア」から STEP / STL / IGES 形式をブラウザ上で 3D 表示できます。旧新図面の比較に加えて、DRBFMの故障モードとCAD上の位置をつなげて確認できます。',
      categoryQuestion: 'ドキュメントのカテゴリーはどのように選べばいいですか？',
      categoryAnswer: 'アップロード時にカテゴリーを選択できます。「設計基準書」「過去トラブル」「技術仕様書」「運用手順書」「一般」から適切なものを選んでください。AIが自動判定することもできます。',
      auditQuestion: '自分や組織の操作履歴はどこで確認できますか？',
      auditAnswer: 'manager・admin ロールは「設定」画面の「アクティビティ・監査ログ」から、あるいは URL `/admin/activity` から、テナント内の操作履歴（ログイン／ドキュメント／チャット／CAD／DRBFM ほか）を確認できます。admin は同画面から監査ログを CSV エクスポートでき、`/admin/anomalies` では異常検知イベント（連続ログイン失敗・テナント境界違反など）の triage と解決済みマーキングが行えます。一般ユーザーに対しては権限上の理由で表示されません。',
      securityQuestion: 'ドキュメントのセキュリティはどうなっていますか？',
      securityAnswer: 'テナント単位でアクセスが分離されており、許可されたユーザーのみがドキュメントにアクセスできます。JWT 認証と MFA（多要素認証）に対応し、主要操作は監査ログに記録されます。異常検知（連続ログイン失敗・テナント境界違反など）は Slack 通知と App Insights への構造化ログ送出で運用チームが監視しています。',
    },
    features: {
      search: 'AIセマンティック検索',
      searchDesc: 'キーワードや自然文で検索し、関連文書、抜粋、参照元ページを確認できます。',
      upload: 'ドキュメントアップロード',
      uploadDesc: 'AI がタイトル・要約・カテゴリ・タグを自動抽出し、図面や画像も含めて全文検索可能にします。',
      chat: 'AIチャットアシスタント',
      chatDesc: 'ドキュメントに関する質問に AI が回答。ファイル単位のスコープ指定、Web検索の切り替え、参照文書の関連度や根拠を確認できます。',
      drbfm: 'DRBFM分析',
      drbfmDesc: '旧／新仕様書の比較から心配点・対策を生成。関連知識を実ファイルリンク・抜粋・関連度付きで確認できます。',
      verification: '設計検証項目一覧',
      verificationDesc: '検証項目の作成・管理・Excel 出力に対応。DRBFM 分析結果から検証項目を生成し、元の分析結果へ戻って確認できます。',
      cad: '3D CAD ビューア',
      cadDesc: 'STEP / STL / IGES をブラウザ上で 3D 表示。旧新図面の比較や、DRBFMの故障モードとCAD上の位置をつなげて確認できます。',
      audit: 'アクティビティ・監査ログ（管理者向け）',
      auditDesc: 'ログイン／ドキュメント／チャット／CAD／DRBFM など主要操作を記録。監査ログ、異常検知、CSVエクスポートを管理画面から確認できます。',
      security: 'セキュアな文書管理',
      securityDesc: 'テナント単位のアクセス制御、JWT 認証、MFA、監査ログ、異常検知通知を組み合わせた多層的な安全対策を提供します。',
    },
    title: 'ヘルプ',
    description: 'REVY の使い方とよくある質問',
    featuresTitle: '主な機能',
    faqTitle: 'よくある質問',
    tipsTitle: 'クイックヒント',
    tip1: '検索時は具体的なキーワードを使うと、より正確な結果が得られます',
    tip2: 'ドキュメントにタグを追加すると、後で見つけやすくなります',
    tip3: 'AIチャットでは、質問を具体的にすると良い回答が得られます',
    tip4: 'サイドバーはミニモードに切り替えると、作業スペースを広く使えます',
    tip5: '設計検証項目一覧はExcelに出力して、チーム内で共有できます',
    contactTitle: 'お問い合わせ',
    contactDescription: 'その他のご質問やサポートが必要な場合は、システム管理者にお問い合わせください。',
    categories: {
      search: '検索',
      upload: 'アップロード',
      category: '分類',
      chat: 'チャット',
      chatFileScope: 'ファイル指定',
      drbfm: 'DRBFM',
      verification: '設計検証',
      cad: 'CAD',
      audit: '監査',
      security: 'セキュリティ',
    },
  };

export default help;
